// extracted by mini-css-extract-plugin
export default {"Content":"style_Content__FG02H","Wrapper":"style_Wrapper__OXu4r","Header":"style_Header__Ldvwh","Body":"style_Body__6Fipu"};